import { JsonConverter } from 'json2typescript';
import { BidVersionType } from '@qv-bid/enums';
import { EnumConverter } from './enum.converter';

@JsonConverter
export class BidVersionTypeConverter extends EnumConverter<BidVersionType> {
  protected enumInstance = BidVersionType;
}
